import { LockKeyhole, RefreshCw } from "lucide-react"
import { useAuth } from "@pma/stores/auth-store"
import { usePermissions } from "@pma/hooks/use-permissions"
import { Card, CardContent } from "@components/common/card"
import { Button } from "@components/common/button"
import { cn } from "@pma/utils/helpers"
import useTranslator from "@hooks/use-translator"

const FinancialAccessDenied = () => {
  const { translate, locale } = useTranslator()
  const { authConfig } = useAuth()
  const { currentOrg } = usePermissions()

  const isRtl = locale === "he"

  const userName: string =
    authConfig?.first_name && authConfig?.last_name
      ? `${authConfig.first_name} ${authConfig.last_name}`
      : authConfig?.name || authConfig?.email || ""

  const orgName: string = currentOrg?.name || currentOrg?.company_name || ""

  return (
    <div
      className={cn(
        "flex h-full w-full items-center justify-center p-6",
        isRtl && "dir-rtl",
      )}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <Card className="w-full max-w-md text-center shadow-lg">
        <CardContent className="flex flex-col items-center gap-6 py-12">
          <div className="flex items-center justify-center rounded-full bg-muted p-5">
            <LockKeyhole size={64} className="text-muted-foreground" />
          </div>

          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-semibold leading-tight tracking-tight">
              {translate("You don't have access to the financial module")}
            </h2>

            {(userName || orgName) && (
              <p className="text-sm text-muted-foreground">
                {userName && (
                  <span className="font-medium">{userName}</span>
                )}
                {userName && orgName && " · "}
                {orgName && (
                  <span className="font-medium">{orgName}</span>
                )}
              </p>
            )}
          </div>

          <p className="text-sm text-muted-foreground">
            {translate("Contact your organization admin to get access")}
          </p>

          <Button
            variant="outline"
            size="sm"
            onClick={() => window.location.reload()}
            className="mt-2 gap-2"
          >
            <RefreshCw size={14} />
            {isRtl ? "נסה שוב" : "Try again"}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}

export default FinancialAccessDenied
